import {PayloadAction} from "../payload-action.interface";
import {ContactEntity} from "./contact.entity";


export class ContactActions{
  static readonly ADD 		  = '[ContactActions] ADD';
  static readonly ADD_ALL 	= '[ContactActions] ADD_ALL';
  static readonly REMOVE 		= '[ContactActions] REMOVE';
  static readonly SET 		  = '[ContactActions] SET';

  static addAll(contacts: Array<ContactEntity>): PayloadAction{
    return {
      type: ContactActions.ADD_ALL,
      payload: contacts
    }
  }

  static add(contact: ContactEntity): PayloadAction{
    return {
      type: ContactActions.ADD,
      payload: contact
    }
  }

  static set(contact: ContactEntity): PayloadAction{

    return {
      type: ContactActions.SET,
      payload: contact
    }
  }

  static remove(id: string): PayloadAction{
    return {
      type: ContactActions.REMOVE,
      payload: id
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/contact/contact.actions.ts